var _a;
import { __read } from "tslib";
import { useEffect, useReducer, useState } from 'react';
import { PROJECT_GRID_BREAKPOINTS } from './breakpoints';
export var NO_BREAKPOINT = 'none';
var SMALL_BREAKPOINT = 'small';
var MEDIUM_BREAKPOINT = 'medium';
var LARGE_BREAKPOINT = 'large';
var EXTRA_LARGE_BREAKPOINT = 'extraLarge';
var EXTRA_EXTRA_LARGE_BREAKPOINT = 'extraExtraLarge';
export var gridImagesPerBreakpoint = (_a = {},
    _a[NO_BREAKPOINT] = [1, 1, 1],
    _a[SMALL_BREAKPOINT] = [4, 3, 2],
    _a[MEDIUM_BREAKPOINT] = [5, 4, 3],
    _a[LARGE_BREAKPOINT] = [6, 5, 4],
    _a[EXTRA_LARGE_BREAKPOINT] = [7, 6, 5],
    _a[EXTRA_EXTRA_LARGE_BREAKPOINT] = [8, 7, 6],
    _a);
export function useImagesPerRowHelper() {
    // This is code uses useReducer, rather than useState, because we need to pass
    // imagesPerRow down to a pure component using React.memo (ProjectScreens).
    //
    // When using something like:
    // const [value, setValue] = useState();
    // the setValue function is recreated when the component rerenders, meaning
    // that it cannot be used in conjunction with React.memo, since the render result
    // is memoized by shallowly comparing the props object.
    var _a = __read(useReducer(function (_, value) { return value; }, ''), 2), imagesPerRow = _a[0], setImagesPerRow = _a[1];
    var _b = __read(useState(), 2), breakpointValue = _b[0], setBreakpoint = _b[1];
    var _c = __read(useState(null), 2), sliderPosition = _c[0], setSliderPosition = _c[1];
    useEffect(function () {
        setInitialSliderValues();
        var onStart = function (e) {
            if (e.matches)
                updateSliderValues(NO_BREAKPOINT);
        };
        var onSmall = function (e) {
            if (e.matches)
                updateSliderValues(SMALL_BREAKPOINT);
        };
        var onMed = function (e) {
            if (e.matches)
                updateSliderValues(MEDIUM_BREAKPOINT);
        };
        var onLarge = function (e) {
            if (e.matches)
                updateSliderValues(LARGE_BREAKPOINT);
        };
        var onExtraLarge = function (e) {
            if (e.matches)
                updateSliderValues(EXTRA_LARGE_BREAKPOINT);
        };
        var onExtraExtraLarge = function (e) {
            if (e.matches)
                updateSliderValues(EXTRA_EXTRA_LARGE_BREAKPOINT);
        };
        var breakpoints = [
            [window.matchMedia(PROJECT_GRID_BREAKPOINTS.start), onStart],
            [window.matchMedia(PROJECT_GRID_BREAKPOINTS.small), onSmall],
            [window.matchMedia(PROJECT_GRID_BREAKPOINTS.medium), onMed],
            [window.matchMedia(PROJECT_GRID_BREAKPOINTS.large), onLarge],
            [window.matchMedia(PROJECT_GRID_BREAKPOINTS.extraLarge), onExtraLarge],
            [
                window.matchMedia(PROJECT_GRID_BREAKPOINTS.extraExtraLarge),
                onExtraExtraLarge,
            ],
        ];
        breakpoints.forEach(function (_a) {
            var _b = __read(_a, 2), breakpoint = _b[0], cb = _b[1];
            return breakpoint.addListener(cb);
        });
        return function () {
            // clearing and recreating the listeners every time `sliderPosition` changes is not ideal,
            // but it's better than the alternative of not clearing them at all
            breakpoints.forEach(function (_a) {
                var _b = __read(_a, 2), breakpoint = _b[0], cb = _b[1];
                breakpoint.removeListener(cb);
            });
        };
    }, 
    // using `sliderPosition` here, because we want to access its up to date value
    // in `updateSliderValues` function
    [sliderPosition]);
    function updateSliderValues(breakpointVal) {
        setBreakpoint(breakpointVal);
        if (breakpointVal === NO_BREAKPOINT) {
            // always show just one image on the smallest breakpoint
            setImagesPerRow(1);
        }
        else {
            setImagesPerRow(gridImagesPerBreakpoint[breakpointVal][sliderPosition]);
        }
    }
    function setInitialSliderValues() {
        if (window.matchMedia(PROJECT_GRID_BREAKPOINTS.start).matches) {
            updateSliderValues(NO_BREAKPOINT);
        }
        else if (window.matchMedia(PROJECT_GRID_BREAKPOINTS.small).matches) {
            updateSliderValues(SMALL_BREAKPOINT);
        }
        else if (window.matchMedia(PROJECT_GRID_BREAKPOINTS.medium).matches) {
            updateSliderValues(MEDIUM_BREAKPOINT);
        }
        else if (window.matchMedia(PROJECT_GRID_BREAKPOINTS.large).matches) {
            updateSliderValues(LARGE_BREAKPOINT);
        }
        else if (window.matchMedia(PROJECT_GRID_BREAKPOINTS.extraLarge).matches) {
            updateSliderValues(EXTRA_LARGE_BREAKPOINT);
        }
        else {
            updateSliderValues(EXTRA_EXTRA_LARGE_BREAKPOINT);
        }
    }
    return {
        imagesPerRow: imagesPerRow,
        setImagesPerRow: setImagesPerRow,
        breakpointValue: breakpointValue,
        sliderPosition: sliderPosition,
        setSliderPosition: setSliderPosition,
    };
}
